import React, { useState, useEffect } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';

export const CampaignUtmPieChart = ({
  allInquiries,
  filteredInquiries,
  adParameter,
}) => {
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (allInquiries.data && filteredInquiries.data) {
      let seriesData = [];
      let id = 0;

      seriesData.push({
        id: 0,
        value: allInquiries.total - filteredInquiries.total,
        label: 'No Data',
        color: '#dddddd',
      });
      id++;

      if (filteredInquiries.data) {
        filteredInquiries.data.forEach((item) => {
          const adCookie = JSON.parse(item.adCookie);
          const params = new URLSearchParams(adCookie.url.split('?')[1]);
          const param = params.get(adParameter);
          const element = seriesData.find((s) => s.label === param);

          if (typeof element !== 'undefined') {
            element.value++;
          } else if (param !== null) {
            seriesData.push({ id: id, value: 1, label: param });
            id++;
          } else {
            const noDataElement = seriesData.find((s) => s.label === 'No Data');
            noDataElement.value++;
          }
        });
      }

      const noDataElement = seriesData.find((s) => s.label === 'No Data');
      if (noDataElement.value === 0) {
        const noDataElementIndex = seriesData.findIndex(
          (s) => s.label === 'No Data'
        );
        seriesData.splice(noDataElementIndex, 1);
      }
      setSeries(seriesData);
    }
    // console.log('series', series);
  }, [allInquiries, filteredInquiries]);

  return (
    <PieChart
      series={[
        {
          data: series,
        },
      ]}
      // margin={{ top: 10, bottom: 50, left: 100, right: 100 }}
      slotProps={{
        legend: { hidden: true },
      }}
      // width={800}
      height={400}
    />
  );
};
